export default class Cache {
  constructor() {
    this.content = {};
  }

  get(key) {
    return this.content[key];
  }

  set(key, value) {
    this.content[key] = value;
  }

  delete(key) {
    if (this.content[key]) delete this.content[key];
  }

  clear() {
    this.content = {};
  }
}
